import { useHistoriqueAbonnements } from "../../lib/hooks/useAbonnements";
import { BookOpen, Inbox } from "lucide-react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Skeleton } from "../ui/skeleton";
import { Alert } from "../ui/alert";
import AbonnementItem from "./AbonnementItem";

const BlocHistoriqueAbonnements = () => {
  const [parent] = useAutoAnimate();
  const { data: abonnements, isError } = useHistoriqueAbonnements();

  return (
    <section className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_14px_40px_-34px_rgba(15,23,42,0.5)]'>
      <div className='flex items-center gap-3 border-b border-slate-100 bg-[#fbfaf6] px-5 py-4 sm:px-6'>
        <div className='flex h-10 w-10 items-center justify-center rounded-xl bg-[#f1e8c9] text-[#755c14]'>
          <BookOpen className='h-5 w-5' />
        </div>
        <div>
          <h2 className='font-bold text-slate-950'>Historique d'abonnements</h2>
        </div>
      </div>
      <div className='p-5 sm:p-6'>
        <div ref={parent} className='flex flex-col gap-6'>
          {/* Loading */}
          {!abonnements && (
            <>
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
            </>
          )}

          {/* Error */}
          {isError && (
            <Alert variant={"destructive"} className='text-sm'>
              Une erreur s'est produite au chargement de l'historique
            </Alert>
          )}

          {/* Historique vide */}
          {!!abonnements && abonnements.length === 0 && (
            <div className='flex flex-col items-center py-8 text-center text-slate-500'>
              <Inbox className='mb-3 h-7 w-7 text-slate-300' />
              <p className='text-sm'>Aucun ancien abonnement.</p>
            </div>
          )}

          {/* Data */}
          {!!abonnements && abonnements.map((abo) => <AbonnementItem key={abo.id} abo={abo} />)}
        </div>
      </div>
    </section>
  );
};

export default BlocHistoriqueAbonnements;
